<template>
  <div
    id="toastContainer"
    class="toast-container position-fixed top-0 end-0 p-3"
    style="z-index: 1050"
  >
    <div
      v-for="(toast, index) in toasts"
      :key="index"
      :class="[
        'toast',
        'show',
        'align-items-center',
        'border-0',
        toastClass(toast.type),
      ]"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">
          {{ toast.message }}
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          @click="removeToast(index)"
        ></button>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      toasts: [],
    };
  },
  methods: {
    showToast(message, type = "danger") {
      this.toasts.push({ message, type });
      setTimeout(() => {
        this.toasts.shift();
      }, 5000);
    },
    removeToast(index) {
      this.toasts.splice(index, 1);
    },
    toastClass(type) {
      return `text-bg-${type}`;
    },
  },
};
</script>
  
  <style>
.toast-container {
  width: 350px;
}
</style>
  